import { FC, ReactNode } from 'react';
import {
  StyledPageContainer,
  RowContainer,
  ColumnContainer,
  StyledContentContainer,
} from '../Containers';
import { Typography } from '@flash-tecnologia/hros-web-ui-v2';
import { SubmitFooter } from 'components/Footer/SubmitFooter';
import styled from 'styled-components';

interface BaseLayoutProps {
  children: ReactNode;
  pageTitle: string;
  descriptionTitle: string;
  descriptionSubTitle: string;
  onSubmit?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  loading?: boolean;
  error?: string;
}

export const DescriptionTitleContainer = styled(ColumnContainer)`
  width: 30%;
  @media (max-width: 1250px) {
    width: 100%;
    padding: 0 37px;
    margin-bottom: 25px;
  }
`;

export const PageSubmitLayout: FC<BaseLayoutProps> = ({
  children,
  pageTitle,
  descriptionTitle,
  descriptionSubTitle,
  onSubmit,
  onCancel,
  loading,
  error,
}) => {
  return (
    <StyledPageContainer>
      <Typography variant="headline6" style={{ fontWeight: '700' }}>
        {pageTitle}
      </Typography>
      <RowContainer isReponsive>
        <DescriptionTitleContainer>
          <Typography
            variant="headline8"
            style={{ fontWeight: '700', color: '#F20D7A' }}
          >
            {descriptionTitle}
          </Typography>
          <Typography
            variant="headline9"
            style={{
              marginTop: '15px',
              fontWeight: '400',
              color: '#83727D',
              lineHeight: '22px',
            }}
          >
            {descriptionSubTitle}
            <br />
            <br />
            Dúvidas?{' '}
            <a
              style={{
                color: 'rgb(242, 13, 122)',
                textDecoration: 'underline',
                fontWeight: '600',
              }}
              target="_blank"
              href="https://beneficios.flashapp.com.br/faq/tudo-sobre-processo-de-conhe%C3%A7a-seu-cliente-kyc"
            >
              Clique aqui
            </a>
          </Typography>
        </DescriptionTitleContainer>

        <StyledContentContainer>{children}</StyledContentContainer>
      </RowContainer>
      <div style={{ height: '100%' }}></div>
      <SubmitFooter
        onSubmit={onSubmit}
        onCancel={onCancel}
        loading={loading}
        error={error}
      />
    </StyledPageContainer>
  );
};
